<script>
import {
  required,
} from "vuelidate/lib/validators";
import { notify } from '@/helpers/notify' 

export default {
  name: 'DealerCreateModal',
  props:[
    "list"
  ],
  data() {
    return {
      options: [],
      form: {
        type:''
      },
      submitted: false,
    };
  },
  validations: {
    form: {
      name: { required },
      username: { required },
      password: { required },
      type: { required },
    },
  },
  watch:{
    list(props){
      this.form = {...props}
    }
  },
  methods: {
    handleSubmit() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        if(this.form.id)
          this.update();
        else
          this.create();
      }
    },
    create(){
      this.$http.post('/users/store', this.form)
        .then(resp => {
          this.form = {};
          this.$emit('loadItems');
          return notify.success(resp.data.message)
        })
        .catch(error => error)
    },
    update(){
      this.$http.put('/users/' + this.form.id , this.form)
        .then(resp => {
          this.$emit('loadItems');
          return notify.success(resp.data.message)
        })
        .catch(error => error)
    },
    remove(id){
      this.$http.delete('/users/' + id)
        .then(resp => {
          if(resp.data.code !==  100)  return notify.error(resp.data.message)
           return notify.success(resp.data.message)
         })
        .catch(error => error)
    },
    close(){
      this.$parent.$bvModal.hide('modal-scoped')
    }
  },
};
</script>
<template>
  <b-modal id="modal-scoped" title="Kullanıcı Ekle"  no-close-on-backdrop hide-footer>
      <form @submit.prevent="handleSubmit">
        <div class="row">
             <div class="col-12">
            <div class="mb-3">
              <label for="name">Kullanıcı Tipi</label>
              <select
                    v-model="form.type"
                    class="form-select"
                    :class="{
                    'is-invalid': submitted && $v.form.type.$error,
                    }"
               >
                <option value="admin">Admin</option>
                <option value="dealer">Bayi</option>
                <option value="metro">Metro Bayisi</option>
                <option value="vae">Vae Bayisi</option>
                <option value="tech">Teknik Personel</option>
                <option value="accountant">Muhasebe</option>
                <option value="callcenter">Çağrı Merkezi</option>
              </select>
              <div
                v-if="submitted && !$v.form.type.required"
                class="invalid-feedback"
              >
              Bu alanı doldurmak zorunludur.
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="mb-3">
              <label for="name">İsim Soyisim</label>
              <input
                id="name"
                v-model="form.name"
                type="text"
                class="form-control"
                placeholder="İsim Soyisim"
                :class="{
                  'is-invalid': submitted && $v.form.name.$error,
                }"
              />
              <div
                v-if="submitted && !$v.form.name.required"
                class="invalid-feedback"
              >
              Bu alanı doldurmak zorunludur.
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="mb-3">
              <label for="username">Kullanıcı Adı</label>
              <input
                id="username"
                v-model="form.username"
                type="text"
                class="form-control"
                placeholder="Kullanıcı Adı"
                :class="{
                  'is-invalid': submitted && $v.form.username.$error,
                }"
              />
              <div
                v-if="submitted && !$v.form.username.required"
                class="invalid-feedback"
              >
              Bu alanı doldurmak zorunludur.
              </div>
            </div>
          </div>
           <div class="col-12">
            <div class="mb-3">
              <label for="password">Kullanıcı Şifresi</label>
              <input
                id="password"
                v-model="form.password"
                type="text"
                class="form-control"
                placeholder="Kullanıcı Şifresi"
                :class="{
                  'is-invalid': submitted && $v.form.password.$error,
                }"
              />
              <div
                v-if="submitted && !$v.form.password.required"
                class="invalid-feedback"
              >
              Bu alanı doldurmak zorunludur.
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="mb-3">
              <div class="form-check form-check-success mb-3">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="formsuccess"
                  checked=""
                  v-model="form.status_id"
                />
                <label class="form-check-label" for="formsuccess">
                  Aktif
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-between mt-3">
        <div>
          <b-button variant="danger"  v-if="form.id" @click="remove(form.id)">Sil</b-button>
        </div>
        <div>
          <b-button variant="light" @click="close()">Vazgeç</b-button>
          <b-button 
            v-if="form.id"
            type="submit" 
            variant="warning" 
            class="ms-1"
            >Güncelle
          </b-button>
          <b-button 
            v-else
            type="submit" 
            variant="success" 
            class="ms-1"
            >Oluştur
          </b-button>
        </div>
        </div>
      </form>
    </b-modal>
</template>